// extracted by mini-css-extract-plugin
export default {"tableForm":"ListTableForm_tableForm__Ri5sn"};